var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 75,
    viewBox: "0 0 53 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4912 70.8864C16.896 70.8864 6.22081 58.8288 4.37761 42.4704C4.14721 40.8576 4.0704 39.2448 4.0704 37.5552C4.0704 18.9696 15.4368 4.14716 29.4912 4.14716C36.864 4.14716 43.776 8.21756 49.0752 16.2816L52.5312 13.9776C46.464 4.99196 38.1696 0.0767574 29.4912 0.0767574C13.2864 0.0767574 0 17.0496 0 37.5552C0 39.3216 0.0768144 41.1648 0.307214 42.9312C2.30401 61.056 15.0528 74.9568 29.4912 74.9568C38.1696 74.9568 46.464 70.0416 52.5312 61.1328L49.0752 58.8288C43.776 66.816 36.864 70.8864 29.4912 70.8864Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperC);
export default __webpack_public_path__ + "static/media/UPPER_C.fdb7bc692f612884bcb6c443f3d7e964.svg";
export { ForwardRef as ReactComponent };